// src/components/Post_content.jsx
import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import { useParams } from "react-router-dom";
import { ClipLoader } from "react-spinners";
import AdSense from "react-adsense";

// Nếu mode = "hust_media", sẽ import và render component Posts từ file posts.jsx
import Posts from "./posts.jsx";

const Post_content = ({
  mode,               // mode phải được truyền rõ ràng: "telegram" hoặc "hust_media"
  channel,
  id_post,
  show_adsense,
  show_start_load,
  show_adskeeper,
  uri
}) => {
  // Hooks luôn được gọi ở đầu, không phụ thuộc vào điều kiện
  const { slug_1, slug_2 } = useParams();
  const [showstart, setShowstart] = useState(false);
  const [randomNumber] = useState(() => Math.floor(Math.random() * 10));

  // Hàm tạo script Telegram embed (chỉ dùng khi mode === "telegram")
  function embedtele(value) {
    if (!value) return;
    const match = value.match(/\/([^\/]+)\/(\d+)$/);
    if (!match) return;

    const [, guideName, guideId] = match;
    const script = document.createElement("script");
    script.src = "https://telegram.org/js/telegram-widget.js?22";
    script.async = false;
    script.setAttribute("data-telegram-post", `${guideName}/${guideId}`);
    script.setAttribute("data-width", "100%");

    const telegramDiv = document.getElementById(`telegram_${randomNumber}`);
    if (telegramDiv) telegramDiv.appendChild(script);

    // Cleanup khi unmount hoặc khi giá trị thay đổi
    return () => {
      if (telegramDiv) telegramDiv.removeChild(script);
    };
  }

  // useEffect để chèn Telegram widget khi mode === "telegram"
  useEffect(() => {
    if (mode !== "telegram") return;

    let cleanupFn;
    const embedUrl = channel && id_post
      ? `https://t.me/${channel}/${id_post}`
      : `https://t.me/${slug_1}/${slug_2}`;

    // Delay 100ms để <div> đã tồn tại trên DOM
    const timeoutId = setTimeout(() => {
      cleanupFn = embedtele(embedUrl);
    }, 100);

    return () => {
      clearTimeout(timeoutId);
      if (cleanupFn) cleanupFn();
    };
  }, [mode, randomNumber, channel, id_post, slug_1, slug_2]);

  // useEffect để hiện loader trong 700ms đầu khi mode === "telegram"
  useEffect(() => {
    if (mode !== "telegram") return;

    const timer = setTimeout(() => setShowstart(true), 700);
    return () => clearTimeout(timer);
  }, [mode]);

  return (
    <>
      {/* AdSense: hiển thị bất kể mode nào nếu show_adsense === "YES" hoặc prop không truyền */}
      {(show_adsense === "YES" || !show_adsense) && (
        <div className="max-h-16">
          <div className="cards">
            <AdSense.Google
              client="ca-pub-4574266110812955"
              slot="1627514116"
              style={{ display: "block" }}
              format="horizontal"
              responsive="false"
            />
          </div>
        </div>
      )}

      {/* Nếu mode là hust_media => render Posts và không xử lý Telegram */}
      {mode === "hust_media" && <Posts uri={uri} show_start_load={show_start_load} />}

      {/* Nếu mode là telegram => xử lý Telegram */}
      {mode === "telegram" && (
        <div className="mt-0">
          {/* Loader ban đầu */}
          {(show_start_load === "YES" || !show_start_load) && !showstart && (
            <div className="mt-5 mx-auto flex justify-center items-center">
              <ClipLoader size={90} color="#8a2be2" />
            </div>
          )}
          {/* Div để chèn Telegram widget */}
          <div id={`telegram_${randomNumber}`}></div>
        </div>
      )}

      {/* AdsKeeper: hiển thị bất kể mode nào nếu show_adskeeper === "YES" hoặc prop không truyền */}
      {(show_adskeeper === "YES" || !show_adskeeper) && (
        <>
          <div data-type="_mgwidget" data-widget-id="1662830"></div>
          <Helmet>
            <script>
              {`(function(w,q){w[q] = w[q] || [];w[q].push(["_mgc.load"])})(window,"_mgq");`}
            </script>
          </Helmet>
        </>
      )}
    </>
  );
};

export default Post_content;
